import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import { useJobs } from '../components/JobContext';
import { useSwipeable } from 'react-swipeable';
import Visit from '../components/Visit';
import { 
  FaBuilding, FaMapMarkerAlt, FaClock, FaMoneyBillWave, 
  FaChevronLeft, FaListUl, FaRocket, FaCheckCircle, FaLightbulb, FaShareAlt,
  FaHourglassHalf, FaEye, FaUserCheck, FaTimes,FaEnvelope, FaCopy
} from 'react-icons/fa';
import '../styles/Jobdetails.css';


/* 🔥 AD COMPONENT (FIXED) */

const JobDetails = () => {

  const { jobs = [] } = useJobs();
  const { id } = useParams();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);
  const [searchTerm, setSearchTerm] = useState("");

const safeLower = (text) => (text || "").toLowerCase();

const filteredJobs = jobs.filter(j => {
  const search = safeLower(searchTerm);

  return (
    safeLower(j.title).includes(search) ||
    safeLower(j.company).includes(search) ||
    safeLower(j.role).includes(search) ||
    safeLower(j.location).includes(search)
  );
});
  const [countdown, setCountdown] = useState(40);
  const [isReady, setIsReady] = useState(false);

  const [views, setViews] = useState(Math.floor(Math.random() * 300) + 120);
  const [appliedCount, setAppliedCount] = useState(Math.floor(Math.random() * 50) + 12);

  useEffect(() => {

    setViews(prev => prev + 1);

    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setIsReady(true);
    }

  }, [countdown]);

  const job = jobs.find((job) => String(job.id) === id);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => navigate("/")
  });
const handleApplyClick = () => {
  if (!job) return;

  setAppliedCount(prev => prev + 1);

  const link = job.applyLink || "";

  const isEmail = link.startsWith("mailto:") || (link.includes('@') && !link.startsWith('http'));
  const isPhone = link.startsWith("tel:");

  if (isEmail) {
    setShowEmailModal(true);
    return;
  }

  if (isPhone) {
    setShowPhoneModal(true);
    return;
  }

  if (link) {
    window.open(link, "_blank", "noopener,noreferrer");
  }
};

  const copyEmailToClipboard = () => {
    const cleanEmail = job.applyLink.replace('mailto:', '');
    navigator.clipboard.writeText(cleanEmail);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const handleShare = async () => {

    const shareData = {
      title: job?.title || "Job Opening",
      text: `Check out this job opening for ${job?.title} at ${job?.company}!`,
      url: window.location.href
    };

    try {

      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert("Link copied to clipboard!");
      }

    } catch (err) {
      console.log(err);
    }
  };

  if (!job) {
    return (
      <div className="job-error-container">
        🚫 <p className="job-error">Job not found.</p>
        <button onClick={() => navigate("/")} className="back-nav-btn">Return Home</button>
      </div>
    );
  }

  const renderSalary = () => {
    if (typeof job.salary === "object") {
      return "Multiple Scales";
    }
    return job.salary || "Competitive";
  };

  return (

<div {...swipeHandlers} className="job-page-container">

{/* Modal */}
{showModal && (
<div className="interview-modal-overlay">
<div className="interview-modal-box">

<button
className="modal-close-btn"
onClick={() => setShowModal(false)}
>
<FaTimes />
</button>

<h2>🎯 Preparing for a Job?</h2>

<p>
Boost your chances by checking our
<strong> Interview Preparation Guide</strong>
</p>

<button
className="modal-action-btn"
onClick={()=>{
setShowModal(false)
navigate("/interview")
}}
>
Start Preparation
</button>

</div>
</div>
)}
{/* MODAL 2: Email Application Popup */}
      {showEmailModal && (
        <div className="interview-modal-overlay">
          <div className="interview-modal-box email-popup">
            <button className="modal-close-btn" onClick={() => setShowEmailModal(false)}><FaTimes /></button>
            <div className="email-icon-header"><FaEnvelope size={40} /></div>
            <h2>Apply via Email</h2>
            <p>Please send your updated resume to the employer directly:</p>
            
            <div className="email-copy-box" onClick={copyEmailToClipboard}>
              <code>{job.applyLink.replace('mailto:', '')}</code>
              <FaCopy />
              {copySuccess && <span className="copy-toast">Copied!</span>}
            </div>

            <button 
              className="modal-action-btn" 
              onClick={() => window.location.href = `mailto:${job.applyLink.replace('mailto:', '')}`}
            >
              Compose Email
            </button>
          </div>
        </div>
      )}
  {showPhoneModal && (
  <div className="interview-modal-overlay">
    <div className="interview-modal-box email-popup">

      <button
        className="modal-close-btn"
        onClick={() => setShowPhoneModal(false)}
      >
        <FaTimes />
      </button>

      <div className="email-icon-header">
        📞
      </div>

      <h2>Contact Recruiter</h2>

      <p>Please call the employer using the number below:</p>

      <div
        className="email-copy-box"
        onClick={() => {
          const number = job.applyLink.replace("tel:", "");
          navigator.clipboard.writeText(number);
          setCopySuccess(true);
          setTimeout(() => setCopySuccess(false), 2000);
        }}
      >
        <code>{job.applyLink.replace("tel:", "")}</code>
        <FaCopy />
        {copySuccess && <span className="copy-toast">Copied!</span>}
      </div>

      <button
        className="modal-action-btn"
        onClick={() => window.location.href = job.applyLink}
      >
        Call Now
      </button>

    </div>
  </div>
)}

{/* Sidebar */}

<aside className="job-sidebar">

  {/* BACK BUTTON */}
  <button
    onClick={()=>navigate(-1)}
    className="back-nav-btn"
  >
    <FaChevronLeft/> Back
  </button>


  {/* COMPANY SUMMARY */}
  <div className="sidebar-card company-summary">

    <div className="sidebar-logo">
      {job.imageUrl ? (
        <img
          src={job.imageUrl}
          alt={job.company || job.title}
          style={{ width: "40px", height: "40px", borderRadius: "50%" }}
        />
      ) : (
        <span style={{fontWeight:"bold"}}>
          {(job.company || job.title || "J").charAt(0)}
        </span>
      )}
    </div>

    <h3>{job.company || "Confidential Company"}</h3>

    <p className="verified-text">
      <FaCheckCircle/> Trusted Job Source
    </p>

  </div>


  {/* STATS */}
  <div className="sidebar-card stats-card">

    <div>
      <FaEye/> {views} views
    </div>

    <div>
      <FaUserCheck/> {appliedCount} applied
    </div>

  </div>


  {/* QUICK NAVIGATION */}
  <div className="sidebar-card toc-card">

    <h3>
      <FaListUl/> Quick Navigation
    </h3>

    <nav className="toc-links">

      <a href="#jobDescription">Overview</a>
      <a href="#Skills">Skills</a>
      <a href="#eligibility">Responsibilities</a>
      <a href="#perksBenefits">Perks & Benefits</a>
      <a href="#applicationProcess">Application Process</a>
      <a href="#aboutCompany">About Company</a>
      <a href="#importantNotes">Important Notes</a>
      <a href="#faqSection">FAQs</a>
      <a href="#moreJobs">More Jobs</a>

    </nav>

  </div>


  {/* EXTRA TRUST BLOCK (NEW - VERY IMPORTANT) */}
  <div className="sidebar-card info-card">

    <h3>✅ Job Assurance</h3>

    <ul className="skill-list">
      <li>We do not charge any fees</li>
      <li>Verified job sources only</li>
      <li>Apply through official links</li>
      <li>Beware of fake recruiters</li>
    </ul>

  </div>

</aside>

{/* Main Content */}

<main className="job-main-content">

<header className="job-banner">

<div className="badge-group">


<span className="time-badge">
<FaClock/> {job.postedDate || "Just Now"}
</span>

</div>

<h1 className="job-title-main">
{job.title || "Job Opening"}
</h1>

<div className="job-meta-tags">

<span className="tag">
<FaMapMarkerAlt/> {job.location}
</span>

<span className="tag">
<FaMoneyBillWave/> {renderSalary()}
</span>

<span className="tag">
<FaBuilding/> {job.jobType || "Full Time"}
</span>

</div>

</header>

{/* Job Overview */}

<section id="jobDescription" className="info-section">

  <h3 className="section-heading">
    Job Overview
  </h3>

  <div className="details-grid">

    <div className="detail-item">
      <label>Role</label>
      <p>{job.role || job.title}</p>
    </div>

    <div className="detail-item">
      <label>Experience</label>
      <p>{job.experience || "Freshers"}</p>
    </div>

    <div className="detail-item">
      <label>Batch</label>
      <p>{job.batch || "2024 / 2025 / 2026"}</p>
    </div>

    <div className="detail-item">
      <label>Job ID</label>
      <p>#JF-{id.substring(0,5)}</p>
    </div>

  </div>

  <p className="description-text">
    {job.description || `
      The ${job.title} role at ${job.company} in ${job.location || "various locations"} 
      is an excellent opportunity for ${job.experience || "freshers and experienced candidates"} 
      to build a strong career in ${job.role || "this field"}. 
      This position involves working on real-world tasks, improving technical skills, 
      and contributing to team projects within ${job.company}.
    `}
  </p>

</section>


{/* Walk-in Details (Show only if available) */}
{/* Walk-in Details */}
<section className="info-section" id="walkinDetails">

  <h3 className="section-heading">
    🏢 Walk-in Details
  </h3>

  <div className="details-grid">

    {job.walkinDetails ? (
      <>
        <div className="detail-item">
          <label>Date</label>
          <p>{job.walkinDetails.date}</p>
        </div>

        <div className="detail-item">
          <label>Time</label>
          <p>{job.walkinDetails.time}</p>
        </div>

        <div className="detail-item">
          <label>Venue</label>
          <p>{job.walkinDetails.venue}</p>
        </div>
      </>
    ) : (
      <>
        <div className="detail-item">
          <label>Mode</label>
          <p>
            {`This ${job.title} role at ${job.company} does not have walk-in details. 
            The selection process will be conducted online or through scheduled interviews.`}
          </p>
        </div>

        <div className="detail-item">
          <label>Application Type</label>
          <p>Online Application</p>
        </div>

        <div className="detail-item">
          <label>Location</label>
          <p>{job.location || "As per company requirement"}</p>
        </div>
      </>
    )}

  </div>

</section>
{/* SEO CONTENT */}
<section className="info-section" id="seoContent">
  <h3 className="section-heading">Detailed Job Description</h3>

  <p className="description-text">
    The {job.title} position at {job.company} in {job.location || "various locations"} is a valuable opportunity for 
    {job.experience || "both freshers and experienced candidates"} who are looking to build a career in {job.role || "this field"}. 
    This role focuses on practical exposure, real-time project involvement, and skill enhancement.
  </p>

  <p className="description-text">
    Candidates applying for this role should have knowledge of {job.skills?.slice(0,2).join(", ") || "basic technical concepts"} 
    and the ability to work in a collaborative environment. The job requires strong problem-solving skills, adaptability, 
    and a willingness to learn new technologies.
  </p>

  <p className="description-text">
    {job.company} provides a professional work environment that supports career growth, learning opportunities, 
    and exposure to modern tools and technologies. This {job.title} job is ideal for candidates aiming for long-term 
    career stability and development.
  </p>

  <p className="description-text">
    Interested candidates are advised to apply early, verify details from official sources, and prepare thoroughly 
    for the recruitment process to increase their chances of selection.
  </p>
</section>



{/* Skills */}
<section id="Skills" className="info-section">
  <h3 className="section-heading">Skills Required</h3>

  {job.skills && job.skills.length > 0 ? (
    <ul className="skill-list">
      {job.skills.map((item, index) => (
        <li key={index}>
          <FaCheckCircle /> {item}
        </li>
      ))}
    </ul>
  ) : (
    <ul className="skill-list">
      {[
        `Knowledge of ${job.title || "relevant technologies"} and industry practices`,
        `Ability to work as a ${job.role || "team member"} at ${job.company}`,
        `Understanding of work environment in ${job.location || "the assigned location"}`,
        `Good communication skills for collaboration`,
        `Problem-solving mindset in ${job.role || "daily tasks"}`,
        `Willingness to learn and adapt in ${job.company}'s workflow`,
        `Basic technical and analytical thinking skills`
      ].map((item, index) => (
        <li key={index}>
          <FaCheckCircle /> {item}
        </li>
      ))}
    </ul>
  )}
</section>


{/* Requirements */}
{/* Requirements */}
<section id="eligibility" className="info-section">

  <h3 className="section-heading">
    Responsibilities
  </h3>

  <ul className="skill-list">

    {(job.responsibilities && job.responsibilities.length > 0
      ? job.responsibilities
      : job.requirements && job.requirements.length > 0
      ? job.requirements
      : [
          `Work as a ${job.role || job.title} at ${job.company} and contribute to daily tasks`,
          `Handle responsibilities related to ${job.skills?.[0] || "core job functions"}`,
          `Collaborate with team members in ${job.location || "the assigned location"}`,
          `Assist in planning, execution, and delivery of assigned projects`,
          `Maintain quality standards and meet deadlines set by ${job.company}`,
          `Communicate effectively with internal teams and stakeholders`,
          `Continuously learn and improve skills required for ${job.title}`,
          `Follow company guidelines and professional work practices`,
          `Identify issues and provide solutions in day-to-day tasks`,
          `Support team goals and contribute to overall business objectives`
        ]
    ).map((item, index) => (
      <li key={index}>
        <FaCheckCircle /> {item}
      </li>
    ))}

  </ul>

</section>

{/* Tips Before Applying */}
<section className="info-section" id="tipsBeforeApplying">
  <h3 className="section-heading">💡 Tips Before Applying</h3>

  <ul className="skill-list">
    {(job.tips && job.tips.length > 0
      ? job.tips
      : [
          `Research about ${job.company} and its work culture`,
          `Prepare basics of ${job.role || job.title}`,
          `Update your resume for ${job.title} role`,
          `Practice interview questions related to ${job.skills?.[0] || "core skills"}`,
          `Apply early to increase your chances of selection`,
          `Ensure you meet eligibility criteria for ${job.company}`
        ]
    ).map((tip, index) => (
      <li key={index}>
        <FaLightbulb /> {tip}
      </li>
    ))}
  </ul>
</section>



{/* Perks & Benefits */}
<section className="info-section" id="perksBenefits">
  <h3 className="section-heading">Perks & Benefits</h3>

  {job.perks && job.perks.length > 0 ? (
    <div className="details-grid">
      {job.perks.map((perk, index) => (
        <div className="detail-item" key={index}>
          <label>{perk.label}</label>
          <p>{perk.value}</p>
        </div>
      ))}
    </div>
  ) : (
    <div className="details-grid">
      {[
        { label: "Work Environment", value: `Professional culture at ${job.company}` },
        { label: "Growth", value: `Career growth opportunities in ${job.role || "this field"}` },
        { label: "Learning", value: "Hands-on experience with real-world projects" },
        { label: "Team", value: "Collaborative and supportive team environment" }
      ].map((perk, index) => (
        <div className="detail-item" key={index}>
          <label>{perk.label}</label>
          <p>{perk.value}</p>
        </div>
      ))}
    </div>
  )}
</section>



{/* Application Process */}
<section className="prep-section" id="applicationProcess">
  <h3 className="section-heading">Application Process</h3>

  {job.applicationProcess && job.applicationProcess.length > 0 ? (
    <div className="prep-grid">
      {job.applicationProcess.map((step, index) => (
        <div className="prep-card" key={index}>
          <FaRocket />
          <h4>{step.title}</h4>
          <p>{step.desc}</p>
        </div>
      ))}
    </div>
  ) : (
    <div className="prep-grid">
      {[
        { title: "Apply Online", desc: `Submit application for ${job.title} at ${job.company}` },
        { title: "Screening", desc: "Initial profile shortlisting by HR team" },
        { title: "Interview", desc: `Technical and HR interview rounds for ${job.role || job.title}` },
        { title: "Final Selection", desc: "Offer release for selected candidates" }
      ].map((step, index) => (
        <div className="prep-card" key={index}>
          <FaRocket />
          <h4>{step.title}</h4>
          <p>{step.desc}</p>
        </div>
      ))}
    </div>
  )}
</section>


{/* About Company */}
<section className="info-section" id="aboutCompany">
  <h3 className="section-heading">About the Company</h3>

  <p className="description-text">
    {job.aboutCompany || `${job.company} is an organization that offers opportunities in ${job.role || "multiple domains"}.
    The company focuses on innovation, employee growth, and delivering quality solutions. 
    This ${job.title} role provides a great platform to build a strong and stable career.`}
  </p>
</section>


{/* Important Notes */}
<section className="info-section" id="importantNotes">
  <h3 className="section-heading">Important Notes</h3>

  <ul className="skill-list">
    {(job.notes && job.notes.length > 0
      ? job.notes
      : [
          `Job information for ${job.company} is collected from official and trusted sources`,
          "We do not charge any fees for job applications",
          `Always verify ${job.title} details on the official website`,
          "Beware of fraudulent recruiters asking for payment",
          "Apply only through verified and secure links",
          "Job availability may change without prior notice"
        ]
    ).map((note, index) => (
      <li key={index}>
        <FaCheckCircle /> {note}
      </li>
    ))}
  </ul>
</section>



{/* Urgency Section */}
<section className="prep-section" id="hurryUp">
  <h3 className="section-heading">⚡ Hurry Up</h3>

  <div className="prep-card">
    <p>
      {job.urgencyMessage ||
        `Applications for ${job.title} at ${job.company} are filling quickly. Apply as soon as possible to avoid missing this opportunity.`}
    </p>
  </div>
</section>

<Visit/>

{/* Apply Buttons */}

<div className="action-row">

{isReady ? (

<button
onClick={handleApplyClick}
className="apply-primary-btn"
>

<FaRocket/> Apply Now

</button>

) : (

<button
className="apply-primary-btn disabled-btn"
disabled
>

<FaHourglassHalf/>
Generating Link {countdown}s

</button>

)}

<button
onClick={handleShare}
className="share-btn"
>

<FaShareAlt/> Share

</button>

</div>
{/* FAQ SECTION */}
<section className="info-section" id="faqSection">
  <h3 className="section-heading">❓ Frequently Asked Questions</h3>

  <div className="faq-box">

    <h4>1. Who can apply for the {job.title} role at {job.company}?</h4>
    <p>
      Candidates with {job.experience || "relevant qualifications"} can apply for this position. 
      Both freshers and experienced candidates interested in {job.role || "this field"} are eligible.
    </p>

    <h4>2. Is the {job.title} job remote or onsite?</h4>
    <p>
      This position is based in {job.location || "the specified location"}. 
      Please refer to the official job posting for remote or hybrid work details.
    </p>

    <h4>3. What is the salary for {job.title} at {job.company}?</h4>
    <p>
      The salary for this role is {job.salary || "competitive and will be discussed during the interview process"}. 
      It may vary depending on experience and skills.
    </p>

    <h4>4. Is there any application fee for this job?</h4>
    <p>
      No, applying for the {job.title} position at {job.company} is completely free. 
      Be cautious of any third parties asking for payment.
    </p>

    <h4>5. How can I apply for this job?</h4>
    <p>
      You can apply for the {job.title} role at {job.company} using the Apply Now button provided above. 
      Ensure all details are correct before submitting your application.
    </p>

  </div>
</section>

{/* MORE JOBS SECTION */}

<section className="more-jobs-section" id="moreJobs">

  <h2 className="section-heading">
    🚀 More Jobs You May Like
  </h2>

  <div className="more-jobs-grid">

    {jobs
      .filter(j => j.id !== job.id)
      .slice(0, 8)
      .map((j, index) => (
        <div className="more-job-card" key={j.id}>

          <h3>{j.title}</h3>

          <p>
            <FaBuilding /> {j.company}
          </p>

          <p>
            <FaMapMarkerAlt /> {j.location}
          </p>

          <p>
            <FaMoneyBillWave /> {j.salary || "Competitive"}
          </p>

          <p>
            Experience : {j.experience || "Fresher"}
          </p>

          <div className="job-card-buttons">

            <Link
              to={`/job/${j.id}`}
              className="view-job-btn"
            >
              View Details
            </Link>

            <button
              onClick={() => window.open(j.applyLink, "_blank")}
              className="apply-job-btn"
            >
              Apply
            </button>

          </div>

        </div>
      ))}

  </div>

</section>

</main>
{/* Sidebar */}
<aside className="job-sidebar">

  {/* SEARCH */}
  <div className="sidebar-card search-card">

    <h3>🔎 Search Jobs</h3>

    <input
      type="text"
      placeholder="Search job title, company..."
      value={searchTerm}
      onChange={(e)=>setSearchTerm(e.target.value)}
      className="job-search-input"
    />

    {searchTerm && (
      <ul className="search-results">

        {filteredJobs.length > 0 ? (
          filteredJobs.slice(0,5).map(jobItem => (
            <li key={jobItem.id}>
              <Link to={`/job/${jobItem.id}`}>
                {jobItem.title} at {jobItem.company}
              </Link>
            </li>
          ))
        ) : (
          <li>No jobs found for "{searchTerm}"</li>
        )}

      </ul>
    )}

  </div>


  {/* RECENT JOBS */}
  <div className="sidebar-card recent-jobs">

    <h3>🕒 Recent Jobs</h3>

    <ul className="recent-job-list">

      {jobs.slice(0,6).map(jobItem => (
        <li key={jobItem.id}>

          <Link to={`/job/${jobItem.id}`}>
            <strong>{jobItem.title}</strong>
          </Link>

          <p style={{fontSize:"12px"}}>
            {jobItem.company} • {jobItem.location || "Location not specified"}
          </p>

        </li>
      ))}

    </ul>

  </div>


  {/* QUICK INFO (NEW - boosts AdSense trust) */}
  <div className="sidebar-card info-card">

    <h3>ℹ️ Job Tips</h3>

    <ul className="skill-list">
      <li>Apply early for better chances</li>
      <li>Always verify job details</li>
      <li>Prepare resume before applying</li>
      <li>Avoid paying any application fees</li>
    </ul>

  </div>

</aside>
</div>

  );
};

export default JobDetails;